import React from "react";

/**
 * IMG Monogram - infinity loop + medical cross.
 * variant: "navy" | "teal" | "white"
 * showText: boolean - also render the wordmark
 *
 * IMPORTANT: this component renders into the prerendered HTML (universal SSG)
 * AND must hydrate cleanly on the client. Avoid `style={{...}}` with hex
 * colors — browsers normalise inline-style hex to `rgb()` in serialised HTML
 * which then disagrees with React's render output and triggers a hydration
 * mismatch. Use Tailwind utility classes (no inline style) instead.
 */
export function Logo({ variant = "navy", showText = true, className = "" }) {
  const strokeClass =
    variant === "white"
      ? "stroke-white"
      : variant === "teal"
        ? "stroke-teal"
        : "stroke-navy";
  const accentClass = variant === "navy" ? "fill-teal" : variant === "teal" ? "fill-navy" : "fill-teal";
  const wordClass = variant === "white" ? "text-white" : "text-navy";
  const subClass = variant === "white" ? "text-white/75" : "text-teal";

  return (
    <div className={`inline-flex items-center gap-3 ${className}`} aria-label="Infinity Medical Group">
      <svg viewBox="0 0 64 64" className="h-9 w-9 shrink-0" role="img" aria-hidden="true">
        <g fill="none" className={strokeClass} strokeWidth="4" strokeLinecap="round">
          <path d="M14 32c0-6 4-10 9-10s7 4 9 10c2 6 4 10 9 10s9-4 9-10-4-10-9-10-7 4-9 10c-2 6-4 10-9 10s-9-4-9-10z" />
        </g>
        <g className={accentClass}>
          <rect x="35.5" y="22" width="4" height="20" rx="1.2" />
          <rect x="27.5" y="30" width="20" height="4" rx="1.2" />
        </g>
      </svg>
      {showText && (
        <span className="flex flex-col leading-none">
          <span className={`font-display font-bold text-lg tracking-tight ${wordClass}`}>
            Infinity Medical
          </span>
          <span className={`text-[10px] font-semibold uppercase tracking-[0.22em] ${subClass}`}>
            Group · IMG
          </span>
        </span>
      )}
    </div>
  );
}
